/**
 * Drawer geometry, as plain numbers.
 *
 * Deliberately a leaf module with no imports. The snap math in `./snapPoints` is pure and
 * belongs in the `unit` project, which runs in Node — and `./constants` cannot be imported
 * there, because its colors come from `@procore/core-react`, whose dependency graph touches
 * `Image` at module load. `./constants` re-exports everything here, so this split is
 * invisible to components.
 */

// Layout (relative to other UI elements)
export const DRAWER_LAYOUT = {
    /** Top bar height (for landscape positioning) */
    TOP_BAR_HEIGHT: 64,
    /** Margin from right edge in landscape */
    RIGHT_MARGIN: 12,
    /** Height of the drag handle strip above the header */
    DRAG_HANDLE_HEIGHT: 44,
    /** Minimum height of the drawer's own header row */
    HEADER_MIN_HEIGHT: 48,
    /**
     * Content peek used when the drawer's content owns its header, registers no title row,
     * and has no scrollable region to infer one from. Sized to a standard mobile title row
     * so the collapsed drawer reveals the top of the content rather than a bare handle.
     */
    UNREGISTERED_CONTENT_PEEK: 56,
    /**
     * Ceiling on an inferred content header. A reading above this is far more likely to be
     * a mis-inference — content with no inner scroll region until several screens down —
     * than a real header, and an unbounded peek would leave nothing to collapse.
     */
    MAX_CONTENT_PEEK: 160,
} as const;
